module.exports = __webpack_public_path__ + "static/servercast-9e9cc41d07274759e4b1a383804d9f71.png";